<div class="page-wrapper">
  <div class="page-header list-page-header mb-3 align-items-end">

      <div class="d-flex align-items-center gap-3">
          <h4 class="page-title ">COUPONS</h4>
      </div>


      <div class="tab-actions py-1">
          <div class="d-flex gap-2 align-items-center flex-wrap">

              <div cklass="search-container">
                  <div class="amc-search-bar" (click)="toggleShowSearch()">
                      <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M15.2094 13.7386L12.9178 11.4981L12.8641 11.4164C12.7643 11.317 12.6277 11.261 12.4852 11.261C12.3426 11.261 12.2061 11.317 12.1062 11.4164C10.1587 13.2031 7.15783 13.3002 5.09373 11.6434C3.02964 9.98651 2.54284 7.08981 3.95619 4.87434C5.36953 2.65888 8.24444 1.81213 10.6743 2.89565C13.1041 3.97918 14.3349 6.65676 13.5504 9.15262C13.4939 9.33293 13.5401 9.52901 13.6716 9.66701C13.803 9.805 13.9998 9.86394 14.1878 9.82162C14.3757 9.7793 14.5263 9.64216 14.5828 9.46185C15.5207 6.49999 14.1042 3.3126 11.2498 1.9616C8.39539 0.610603 4.95962 1.50144 3.1651 4.05784C1.37058 6.61423 1.75585 10.069 4.07168 12.1872C6.38752 14.3055 9.93892 14.4515 12.4285 12.5308L14.4575 14.5146C14.6671 14.7186 15.0058 14.7186 15.2154 14.5146C15.4247 14.3077 15.4247 13.9746 15.2154 13.7678L15.2094 13.7386Z"
                              fill="#667085" />
                      </svg>
                      <span>Search</span>
                  </div>
              </div>

              <div class="d-flex flex-row align-items-center text-nowrap">
              <button class="custom-btn-secondary" (click)="openGenerateCouponModal()">
                <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.01886 12.7385C15.5368 14.6813 20.049 6.52126 14.9737 2.01322C14.8625 1.91751 14.6949 1.92997 14.5992 2.04115C14.5035 2.1523 14.5159 2.31996 14.6271 2.41567C19.3384 6.61261 15.0166 14.1541 9.01886 12.1787V10.3741C9.01886 10.1465 8.88113 9.82601 8.22508 9.59182C7.47657 9.32463 6.61303 9.30094 5.83177 9.41138C3.32764 4.52308 8.45268 -0.771705 13.406 1.6103C13.5376 1.6746 13.6967 1.62004 13.7611 1.48825C13.8255 1.35649 13.7709 1.19747 13.6391 1.13306C8.29625 -1.44202 2.71437 4.1878 5.29278 9.52069C5.2134 9.54246 5.13709 9.56608 5.06497 9.59182C4.40892 9.82605 4.27118 10.1465 4.27118 10.3741V12.1418C3.73109 11.8862 3.14869 11.8043 2.43181 11.7946C2.08024 11.8066 2.08013 12.3135 2.43152 12.3257C2.96435 12.326 3.46131 12.3989 3.83091 12.531C4.19466 12.661 4.27121 12.7923 4.27121 12.8128C4.27121 12.8333 4.19452 12.9647 3.82999 13.0948C2.98457 13.3966 1.87207 13.3965 1.02704 13.0948C0.662511 12.9647 0.585816 12.8332 0.585816 12.8128C0.585816 12.7887 0.679012 12.6373 1.12194 12.4993C1.45407 12.383 1.30291 11.8992 0.963909 11.9922C0.212433 12.2265 0.0546875 12.5677 0.0546875 12.8128V17.6138C0.0546875 17.8414 0.192427 18.1619 0.848477 18.3961C1.80869 18.7388 3.04866 18.7387 4.00855 18.3961C4.24717 18.3109 4.41699 18.2142 4.53678 18.1148C4.65656 18.2142 4.82638 18.3109 5.065 18.3961C6.02525 18.7388 7.26522 18.7387 8.22511 18.3961C8.46373 18.3109 8.63355 18.2142 8.75334 18.1148C8.87312 18.2142 9.04294 18.3109 9.28156 18.3961C10.2418 18.7388 11.4817 18.7387 12.4416 18.3961C13.0977 18.1618 13.2354 17.8413 13.2354 17.6138V15.2133C13.2354 14.9856 13.0977 14.6652 12.4416 14.431C11.4814 14.0882 10.2415 14.0883 9.28156 14.431C9.18259 14.4663 9.0956 14.5036 9.0189 14.5423C9.01862 14.1961 9.0194 13.1687 9.01862 12.8075C9.01904 12.7979 9.01879 12.7489 9.01886 12.7385ZM12.7043 16.4135C12.7043 16.434 12.6276 16.5655 12.263 16.6956C11.4176 16.9974 10.3051 16.9973 9.46009 16.6956C9.09556 16.5655 9.01886 16.434 9.01886 16.4135V15.8843C9.09556 15.9229 9.18256 15.9603 9.28153 15.9956C10.2417 16.3384 11.4817 16.3383 12.4416 15.9956C12.5406 15.9603 12.6276 15.9229 12.7043 15.8843V16.4135ZM8.48774 11.5744C8.48774 11.5949 8.41104 11.7264 8.04651 11.8564C7.20109 12.1583 6.08856 12.1582 5.24353 11.8564C4.879 11.7263 4.8023 11.5948 4.8023 11.5744V11.0451C4.879 11.0838 4.966 11.1211 5.06497 11.1565C6.02521 11.4992 7.26518 11.4991 8.22508 11.1565C8.32404 11.1211 8.41104 11.0838 8.48774 11.0451V11.5744ZM5.06497 12.3567C6.11632 12.723 7.4713 12.7127 8.48774 12.2454V12.7937C8.48774 12.8142 8.41104 12.9457 8.04651 13.0758C7.20102 13.3776 6.08863 13.3775 5.24353 13.0758C4.879 12.9457 4.8023 12.8142 4.8023 12.7937V12.2454C4.879 12.284 4.96596 12.3213 5.06497 12.3567ZM4.27118 15.2133C4.27118 15.2338 4.19448 15.3652 3.82995 15.4954C2.98446 15.7972 1.8721 15.797 1.02701 15.4954C0.662476 15.3652 0.585781 15.2338 0.585781 15.2133V14.684C0.662476 14.7226 0.749475 14.76 0.848442 14.7953C1.80865 15.1381 3.04862 15.138 4.00852 14.7953C4.10748 14.76 4.19448 14.7227 4.27118 14.684V15.2133ZM0.585781 15.8842C0.662476 15.9229 0.749475 15.9602 0.848442 15.9956C1.80865 16.3383 3.04862 16.3382 4.00852 15.9956C4.10748 15.9602 4.19448 15.9229 4.27118 15.8842V16.4135C4.27118 16.434 4.19448 16.5655 3.82995 16.6956C2.98453 16.9974 1.87203 16.9972 1.02701 16.6956C0.662476 16.5654 0.585781 16.434 0.585781 16.4135V15.8842ZM4.8023 15.8842C4.879 15.9229 4.966 15.9602 5.06497 15.9956C6.02521 16.3383 7.26518 16.3382 8.22508 15.9956C8.32404 15.9602 8.41104 15.9229 8.48774 15.8842V16.4135C8.48774 16.434 8.41104 16.5655 8.04651 16.6956C7.20109 16.9974 6.08856 16.9973 5.24353 16.6956C4.879 16.5654 4.8023 16.434 4.8023 16.4135V15.8842ZM8.04651 15.4954C7.20102 15.7972 6.08863 15.797 5.24353 15.4954C4.879 15.3652 4.8023 15.2338 4.8023 15.2133V14.684C4.879 14.7226 4.966 14.76 5.06497 14.7953C6.02521 15.1381 7.26518 15.138 8.22508 14.7953C8.32404 14.76 8.41104 14.7227 8.48774 14.684V15.2133C8.48774 15.2338 8.41104 15.3652 8.04651 15.4954ZM8.48774 14.013C8.48774 14.0335 8.41104 14.1649 8.04651 14.2951C7.20102 14.5969 6.08863 14.5967 5.24353 14.2951C4.879 14.1649 4.8023 14.0335 4.8023 14.013V13.4647C4.879 13.5033 4.966 13.5407 5.06497 13.576C6.02521 13.9187 7.26518 13.9186 8.22508 13.576C8.32404 13.5407 8.41104 13.5033 8.48774 13.4647V14.013ZM5.24353 10.092C6.08866 9.79036 7.20163 9.79043 8.04651 10.092C8.41104 10.2222 8.48774 10.3536 8.48774 10.3741C8.48774 10.3946 8.41104 10.5261 8.04651 10.6562C7.20102 10.958 6.08863 10.9578 5.24353 10.6562C4.879 10.5261 4.8023 10.3946 4.8023 10.3741C4.8023 10.3536 4.879 10.2222 5.24353 10.092ZM0.848442 13.595C1.89979 13.9613 3.25474 13.951 4.27118 13.4838V14.013C4.27118 14.0335 4.19448 14.165 3.82995 14.2951C2.98446 14.5969 1.8721 14.5968 1.02701 14.2951C0.662476 14.165 0.585781 14.0335 0.585781 14.013V13.4838C0.66244 13.5224 0.749439 13.5597 0.848442 13.595ZM3.82995 17.8959C2.98446 18.1977 1.8721 18.1976 1.02701 17.8959C0.662476 17.7657 0.585781 17.6343 0.585781 17.6138V17.0845C1.68929 17.5809 3.16795 17.5808 4.27118 17.0845V17.6138C4.27118 17.6343 4.19448 17.7657 3.82995 17.8959ZM8.04651 17.8959C7.20102 18.1977 6.08863 18.1975 5.24353 17.8959C4.879 17.7657 4.8023 17.6343 4.8023 17.6138V17.0845C5.90581 17.5809 7.38451 17.5808 8.48774 17.0845V17.6138C8.48774 17.6343 8.41104 17.7657 8.04651 17.8959ZM12.263 17.8959C11.4175 18.1977 10.3052 18.1976 9.46009 17.8959C9.09556 17.7657 9.01886 17.6343 9.01886 17.6138V17.0845C10.1224 17.5809 11.601 17.5808 12.7043 17.0845V17.6138C12.7043 17.6343 12.6276 17.7657 12.263 17.8959ZM9.46009 14.9312C10.3056 14.6294 11.4179 14.6295 12.263 14.9312C12.6276 15.0613 12.7043 15.1928 12.7043 15.2133C12.7043 15.2337 12.6276 15.3652 12.263 15.4954C11.4175 15.7972 10.3052 15.797 9.46009 15.4954C9.09556 15.3652 9.01886 15.2338 9.01886 15.2133C9.01886 15.1927 9.09556 15.0613 9.46009 14.9312Z"
                    fill="white" />
                </svg>
                Generate Coupon
              </button>
            </div>


          </div>


      </div>
  </div>



  <div class="panel-div">

      <form class="search-form" [formGroup]="form" *ngIf="showSearchForm">

          <div class="row mt-2 g-3">
              <div class="col-md-4">
                  <div class="field">
                      <label class="form-label">Email</label>
                      <input type="text" class="form-control" formControlName="email" />
                  </div>
              </div>

              <div class="col-md-4">
                  <div class="field">
                      <label class="form-label">Status</label>
                      <select class="form-select small-option-font" formControlName="status">
                          <option value="">-- Select Status --</option>
                          <option value="SUCCESS">Used</option>
                          <option value="ACTIVE">Unused</option>
                      </select>
                  </div>
              </div>


              <div class="col-md-4">
                  <div class="field">
                      <label class="form-label">Payment Reference</label>
                      <input type="text" class="form-control" formControlName="paymentReference" />
                  </div>
              </div>
              <div class="col-md-4">
                  <div class="field">
                      <label class="form-label">Start Date</label>
                      <input type="date" class="form-control" formControlName="from" />
                  </div>
              </div>

              <div class="col-md-4">
                  <div class="field">
                      <label class="form-label">End Date</label>
                      <input type="date" class="form-control" formControlName="to" />
                  </div>
              </div>
          </div>

          <span class="material-symbols-outlined text-danger" style="position: absolute; top: 5px; right: 10px;"
              role="button" (click)="toggleShowSearch()">close</span>


          <div class="actions d-flex align-items-end">
              <span class="clear-all-btn" role="button" (click)="clearSearchFilters()">Clear all filters</span>

              <button class="custom-btn-primary search-button ms-auto" [disabled]="form.pristine"
                  (click)="search(); toggleShowSearch()">Search</button>

          </div>
      </form>

      <div class="table-wrapper border-radius-full">
          <table class="role-table amc-table" appAutoDataLabel>
              <thead class="amc-table-heading">
                  <tr>
                      <th>S/N</th>
                      <th>Email</th>
                      <th>Amount</th>
                      <th>Payment Ref.</th>
                      <th>Date Generated</th>
                      <th>Status</th>
                      <th>Generated By</th>
                  </tr>
              </thead>

              <tbody>
                  <tr *ngFor="let item of data; let i = index">
                      <td>{{ i + (currentPage -1) + 1 }}</td>
                      <td>{{ item?.email }}</td>
                      <td>{{ item?.couponValue | nairaCurrency}}</td>
                      <td>{{ item?.paymentReference | uppercase }}</td>
                      <td>{{ item?.createdDate | date }}</td>
                      <td>{{ item?.status}}</td>
                      <td>{{ item?.generatedBy | titlecase}}</td>

                  </tr>
              </tbody>
          </table>

          <div class="d-flex justify-content-center action-icon p-3">
              @if(isSearching){
              <app-bounce-loader></app-bounce-loader>
              }

              @if(errorFetchingData) {
              <span class="text-danger">
                  Error fetching data
              </span>
              }

              @if(searchedDataNotFound) {
              <span class="text-danger">
                  No records found
              </span>
              }

              <p *ngIf="!data && !(errorFetchingData || isSearching || searchedDataNotFound)">
                  Please perform a search to view data.
              </p>


          </div>



      </div>




  </div>

  <div class="d-flex justify-content-between align-items-center mt-2 flex-wrap">

      <div class="d-flex align-items-center me-4">
          <div>Rows per page: </div>
          <div class="mx-2">
              <select class="form-control px-6 text-center" style="width: auto; min-width: 40px;"
                  [(ngModel)]="selectedLimit" (change)="updateLimit()">
                  <option [value]=5>5</option>
                  <option [value]=10>10</option>
                  <option [value]=20>20</option>
                  <option [value]=30>30</option>
                  <option [value]=40>40</option>
                  <option [value]=50>50</option>

              </select>
          </div>
      </div>


      <div class="pagination-container">
          <ngb-pagination *ngIf="!isSearching && count > 0" [(page)]="currentPage" (pageChange)="callDb($event)"
              [maxSize]="5" [pageSize]="pageSize" [collectionSize]="count" [boundaryLinks]="true"
              [directionLinks]="true" [rotate]="true" class="pagination justify-content-center my-3">
          </ngb-pagination>
      </div>
  </div>
</div>